import { eExternalOrderStatus } from '../../ui-toolkit/enums/eExternalOrderStatus';
import { IClientOrderData } from '../../types/clientPortal/IClientOrderData';

const permanentExternalOrderStatuses: Set<eExternalOrderStatus | undefined> = new Set([
  eExternalOrderStatus.signing_scheduled,
  eExternalOrderStatus.signing_confirmed,
  eExternalOrderStatus.signing_occurred,
  eExternalOrderStatus.waiting_for_funds,
  eExternalOrderStatus.funded,
  eExternalOrderStatus.recorded,
  eExternalOrderStatus.funded_and_recorded,
  eExternalOrderStatus.policy_issued,
  eExternalOrderStatus.cancelled,
]);

export const isLoanAmountEditable = (orderData?: IClientOrderData): boolean =>
  !permanentExternalOrderStatuses.has(orderData?.orderStatus);
